import React from "react"
import { Drawer, RaisedButton, CircularProgress } from "material-ui"
import autobind from "class-autobind"
import _ from "lodash"
import * as api from "../../../api"
import strings from "../../../localization/strings"
import { IJobFilter, IDate, IPayrollPayCalendar, EDayOfWeek, IMultiJobsBudgetData } from "../../../models"
import AppStateStore from "../../../stores/AppStateStore"
import DateRangeSelect_SelectWeek from "../../common/DateRangeSelect_SelectWeek"
import moment from "moment"
import ConsolidatedTimecardTimeSummary from "../consolidated-timecard/ConsolidatedTimecardTimeSummary"
import BudgetByJob from "./BudgetByJob"
import * as timecardHelper from "../../../helpers/timecardHelper"
import { checkJobFieldAvailable } from "../../../helpers/jobHelper"
import accountStore from "../../../stores/AccountStore"
interface IProps {
    open: boolean
    jobsCount: number
    jobFilter: IJobFilter
    handleClose(): void
}
interface IState {
    calcualteStartDateLocalUTCFormat: IDate
    calcualteEndDateLocalUTCFormat: IDate
    calculating: boolean
    loadingBudget: boolean
    multiJobsBudgetData: IMultiJobsBudgetData
}

export default class JobsViewBudgetDrawer extends React.Component<IProps, IState> {
    private mondayPayCalendar = {
        PayPeriodStartDay: EDayOfWeek.Monday,
        PayPeriodDayStartTime24Hour: 0,
        PayPeriodNumberOfWeeks: 1
    } as IPayrollPayCalendar
    constructor(props: IProps) {
        super(props)
        const calcualteStartEndDateLocalUTCFormat = this.getCalcualteStartEndDateLocalUTCFormat(props.jobFilter)
        this.state = {
            calcualteStartDateLocalUTCFormat: calcualteStartEndDateLocalUTCFormat.calcualteStartDateLocalUTCFormat,
            calcualteEndDateLocalUTCFormat: calcualteStartEndDateLocalUTCFormat.calcualteEndDateLocalUTCFormat,
            calculating: false,
            loadingBudget: false,
            multiJobsBudgetData: null
        }
        autobind(this)
    }

    componentWillReceiveProps(nextProps: IProps) {
        if (_.isEqual(this.props.jobFilter, nextProps.jobFilter)) return
        const calcualteStartEndDateLocalUTCFormat = this.getCalcualteStartEndDateLocalUTCFormat(nextProps.jobFilter)
        this.setState({
            calcualteStartDateLocalUTCFormat: calcualteStartEndDateLocalUTCFormat.calcualteStartDateLocalUTCFormat,
            calcualteEndDateLocalUTCFormat: calcualteStartEndDateLocalUTCFormat.calcualteEndDateLocalUTCFormat
        })
    }

    getCalcualteStartEndDateLocalUTCFormat(jobFilter: IJobFilter) {
        const thisWeekDates = timecardHelper.getTimecardDateByPayrollPayCalendar(moment(), this.mondayPayCalendar)
        const calcualteStartDateLocalUTCFormat = moment(thisWeekDates.StartDate).utc(true).format()
        const calcualteEndDateLocalUTCFormat = moment(thisWeekDates.EndDate).utc(true).format()
        return { calcualteStartDateLocalUTCFormat, calcualteEndDateLocalUTCFormat }
    }

    getJobsBudgetData() {
        this.setState({ loadingBudget: true }, () => {
            api.getMultiJobsBudgetData(
                this.props.jobFilter,
                this.state.calcualteStartDateLocalUTCFormat,
                moment(this.state.calcualteEndDateLocalUTCFormat).parseZone().endOf("day").utc(true).format()
            ).then(res =>
                this.setState({
                    loadingBudget: false,
                    multiJobsBudgetData: res.data
                })
            )
        })
    }

    handleClose() {
        this.setState({ multiJobsBudgetData: null, calculating: false, loadingBudget: false })
        this.props.handleClose()
    }

    render() {
        return (
            <Drawer
                open={this.props.open}
                openSecondary
                width={1200}
                docked={false}
                overlayStyle={{ zIndex: 1500 }}
                containerStyle={{ zIndex: 1500, overflow: "unset", opacity: open ? 1 : 0, transition: "opacity 200ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms" }}
                onRequestChange={this.handleClose}
            >
                <div style={{ padding: 35, backgroundColor: AppStateStore.getDrawerHeaderColor(), textAlign: "center", color: "#ffffff", fontWeight: "normal", fontSize: 25 }}>
                    {checkJobFieldAvailable('plural') ? `Multiple ${accountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel} Budget Data` : strings.Multiple_Jobs_Budget_Data}
                    <i className="fa fa-close itemActionButton" style={{ float: "right" }} onClick={this.handleClose} />
                </div>
                {this.props.jobsCount > 100 ?
                    <div style={{ textAlign: "center" }}>
                        <div style={{ fontSize: 16, fontWeight: 500, marginTop: 50 }}>
                            {strings.Cannot_calculate_budget_for_more_than_100_Jobs}
                        </div>
                        <div>
                            {strings.Please_narrow_your_search_criteria_to_fewer_than_100_jobs_to_see_the_calculated_real_time_budget_data}
                        </div>
                    </div> :
                    <div style={{ padding: 20 }}>
                        <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center" }}>
                            <DateRangeSelect_SelectWeek
                                startDate={this.state.calcualteStartDateLocalUTCFormat}
                                endDate={this.state.calcualteEndDateLocalUTCFormat}
                                sameDatesAllowed
                                selectedPayrollPayCalendar={this.mondayPayCalendar}
                                handleChange={(startDate, endDate, isValid) =>
                                    isValid &&
                                    this.setState({
                                        calculating: false,
                                        multiJobsBudgetData: null,
                                        calcualteStartDateLocalUTCFormat: startDate,
                                        calcualteEndDateLocalUTCFormat: endDate
                                    })
                                }
                            />
                            <div>
                                <RaisedButton
                                    data-intercom-target={"Jobs-ViewBudget-Drawer-Calculate"}
                                    secondary
                                    disabled={this.state.loadingBudget}
                                    label={strings.Calculate_Budget}
                                    onTouchTap={() => {
                                        (!this.state.calcualteStartDateLocalUTCFormat || !this.state.calcualteEndDateLocalUTCFormat) ?
                                            AppStateStore.setAlertDialogContent({
                                                content: strings.Please_select_start_end_dates
                                            }) :
                                            this.setState({ calculating: true, loadingBudget: true }, () =>
                                                this.getJobsBudgetData()
                                            )
                                    }}
                                />
                            </div>
                        </div>
                        {this.props.open && this.state.calculating &&
                            <div style={{ overflow: "auto", height: "calc(100vh - 190px)" }}>
                                {this.state.loadingBudget ?
                                    <div className="spinner">
                                        <CircularProgress />
                                    </div> :
                                    <div>
                                        <ConsolidatedTimecardTimeSummary
                                            consolidatedTimecardTimeSummary={this.state.multiJobsBudgetData.TotalBudgetData.BudgetData}
                                        />
                                        <BudgetByJob
                                            multiJobsBudgetData={this.state.multiJobsBudgetData}
                                        />
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            </Drawer>
        )
    }
}